import { LocaleType } from '../types/i18n';

// Add supported languages' locale to the array  (eg: fr, es)
export const supportedLanguages: LocaleType[] = ['en'];
